import React, { useCallback } from 'react';
import IconComponent from '../../icons/Icon';
import clsx from 'clsx';
import HighlightedText from '../highlighted-text/HighlightedText';

const AccessItem = ({ Icon, onClick, user, disabled, searchStr, extraClassName }) => {
  const handleClick = useCallback(() => {
    if (!onClick || disabled) {
      return;
    }

    onClick(user);
  }, [onClick, user, disabled]);

  return (
    <div
      className={clsx(
        'access_containers_container_item',
        disabled && 'access_containers_container_item--disabled',
        extraClassName,
      )}>
      <div>
        <HighlightedText value={user.name} searchTerm={searchStr} />
      </div>
      <IconComponent icon={Icon} className={`access_containers_container_item_icon`} onClick={handleClick} />
    </div>
  );
};

export default AccessItem;
